import React, { useEffect, useRef } from "react";
import AppBar from "../../Components/AppBar";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import { useRouteMatch } from "react-router-dom";
import { usePictureSet } from "../../hooks/usePictureSet";
import SubjectSelector from "../../Components/SubjectSelector";
import { callAPI } from "../../../../lib/common";
import { usePictureSets } from "../../../hooks/usePictureSets";
import { useShoppingCart } from "../../../providers/ShoppingCartProvider";
import { generatePath, useHistory } from "react-router";
import useRoutes from "../../../hooks/useRoutes";
import Box from "@mui/material/Box";
import usePictureSetsAvailableToBuyDigitally from "../../../hooks/usePictureSetsAvailableToBuyDigitally";
import PictureSetType from "@/react/Webshop/Mobile/Pages/DigitalPortraitsSubject/Components/PictureSetType";
const DigitalPortraitsSubject = () => {
    const { params } = useRouteMatch();
    const { notFound, pictureSet } = usePictureSet(params.subjectUuid);
    const { update: updatePictureSets, isLoaded, currentPictureSet, pictureSets, setCurrentPictureSet, } = usePictureSets();
    const pictureSetsAvailableToBuyDigitally = usePictureSetsAvailableToBuyDigitally();
    const { updateCart } = useShoppingCart();
    const routes = useRoutes();
    const history = useHistory();
    const isFirstLoad = useRef(true);
    // If we change the subject in the selector, reload the page:
    useEffect(() => {
        if (!currentPictureSet || !pictureSets) {
            return;
        }
        // The first load, we need to respect the path, afterwards we update path/url from currentSubject:
        if (isFirstLoad.current) {
            if (currentPictureSet.subject.uuid != params.subjectUuid) {
                const pictureSet = pictureSets.find((pictureSet) => pictureSet.subject.uuid == params.subjectUuid);
                if (pictureSet) {
                    setCurrentPictureSet(pictureSet);
                }
            }
            isFirstLoad.current = false;
        }
        else if (currentPictureSet.subject.uuid != params.subjectUuid) {
            const link = generatePath(routes["products.digitalportraits.subject"].path, { subjectUuid: currentPictureSet.subject.uuid });
            history.replace(link);
        }
    }, [currentPictureSet, params.subjectUuid]);
    const toggleSetInCart = (pictureSet, type) => {
        console.log("Toggle set in cart!");
        console.log("The picture set", pictureSet);
        callAPI("/ajax/cart/toggle_digital_set_in_cart.php", "POST", {
            pictureSet: pictureSet.subject.uuid,
            type,
        }).then((data) => {
            if (window.isEpmsAnalyticsFeatureEnabled && window.epmsAnalytics) {
                window.epmsAnalytics.onCartChange(data);
            }
            updatePictureSets().then(updateCart);
        });
    };
    if (!pictureSet) {
        return (React.createElement("div", null,
            React.createElement(Trans, null, "Picture set not found")));
    }
    return (React.createElement(MobilePage, null,
        React.createElement(AppBar, null),
        React.createElement(PageHeader, null,
            React.createElement(Trans, null, "Buy digital files")),
        React.createElement(Box, { mb: 4 },
            React.createElement(SubjectSelector, { pictureSets: pictureSetsAvailableToBuyDigitally, legend: false, disableGutters: false })),
        React.createElement(PictureSetType, { type: "IP", toggleSetInCart: toggleSetInCart, pictureSet: pictureSet }),
        React.createElement(PictureSetType, { type: "SFP", toggleSetInCart: toggleSetInCart, pictureSet: pictureSet }),
        React.createElement(PictureSetType, { type: "GP", toggleSetInCart: toggleSetInCart, pictureSet: pictureSet })));
};
export default DigitalPortraitsSubject;
